import React, { useEffect, useRef, useState } from 'react';
import Buttons from '../../../components/ui/button/Buttons';
import { AddApplicationFormData } from './config/AddApplication.data';
import ToastService from '../../../services/toastService/ToastService';
import FormCreator from '../../../components/finalForms/forms/FormCreator';
import { useAddThirdPartyApplicationMutation } from '../../../app/services/configurationAPI';
import { onResetForm } from '../../../components/finalForms/forms/libs/data/mangeFieldSettings';

const AddApplication = (props) => {
  const userId = sessionStorage.getItem('userId');
  const formRef = useRef();

  const [addThirdPartyApplication, { isLoading, isSuccess, data }] =
    useAddThirdPartyApplicationMutation();  

  const [formData, setFormData] = useState(AddApplicationFormData);

  const handleSave = () => {
    const formVal = formRef.current.getFormData();

    if (formVal) {
      const requestData = {
        thirdPartyAppName: formVal.applicationName,
        clientId: formVal.clientKey,
        secretKey: formVal.secretKey,
        isActive: formVal.isActive,
        createdBy: userId
      };

      console.log(requestData);
      

      addThirdPartyApplication(requestData);
      
    }
  };

  useEffect(() => {
    if (isSuccess && data) {
      if (data.keyValue !== 0) {
        ToastService.success(data.errorMessage || "Application added successfully");
        onResetForm(formData, setFormData, null);
        props.handleClose();
      } else {
        const errorMessages = data.errorMessage ? data.errorMessage.split('.').filter(msg => msg.trim() !== '') : ["Failed to add application."];
        errorMessages.forEach(msg => ToastService.warning(msg.trim() + "."));
      }
    }
  }, [isSuccess, data]);

  return (
    <>
      <form>
        <div className="row">
          <FormCreator ref={formRef} config={formData} />
        </div>
      </form>
      <div className="row mt-2 mb-1">
        <div className="col-12">
          <div className="form-btn d-flex justify-content-end">
            <Buttons
              buttonTypeClassName="dark-btn"
              onClick={props.handleClose}
              buttonText="Cancel"
            />
            <Buttons
              buttonTypeClassName="theme-button ml-5"
              onClick={handleSave}
              // buttonText={`${pictogramAssetId ? 'Update' : 'Add'}`}
              buttonText={`Add`}
              // isLoading={isLoading}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AddApplication;